export default __webpack_public_path__ + "static/override-feature-flag-light-mode-27312278da704e2f22701392fea0157e.mp4";